module.exports = __webpack_public_path__ + "static/media/shieldShape90hollow.abbf1853.png";